const STORAGE_KEYS = {
  LOGIN_KEY: 'toc_guest_login_key',
  EMAIL: 'toc_guest_email',
  ACTIVE_EVENT: 'toc_guest_active_event',
} as const;

export function getLoginKey(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEYS.LOGIN_KEY);
  } catch {
    console.error('Error reading login key from storage');
    return null;
  }
}

export function setLoginKey(loginKey: string | null): void {
  try {
    if (loginKey) {
      localStorage.setItem(STORAGE_KEYS.LOGIN_KEY, loginKey);
    } else {
      localStorage.removeItem(STORAGE_KEYS.LOGIN_KEY);
    }
  } catch {
    console.error('Error storing login key');
  }
}

export function getEmail(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEYS.EMAIL);
  } catch {
    console.error('Error reading email from storage');
    return null;
  }
}

export function setEmail(email: string | null): void {
  try {
    if (email) {
      localStorage.setItem(STORAGE_KEYS.EMAIL, email);
    } else {
      localStorage.removeItem(STORAGE_KEYS.EMAIL);
    }
  } catch {
    console.error('Error storing email');
  }
}

export function getActiveEvent(): number | null {
  try {
    const value = localStorage.getItem(STORAGE_KEYS.ACTIVE_EVENT);
    return value ? JSON.parse(value) : null;
  } catch {
    console.error('Error reading active event from storage');
    return null;
  }
}

export function setActiveEvent(eventIndex: number | null): void {
  try {
    if (eventIndex !== null) {
      localStorage.setItem(STORAGE_KEYS.ACTIVE_EVENT, JSON.stringify(eventIndex));
    } else {
      localStorage.removeItem(STORAGE_KEYS.ACTIVE_EVENT);
    }
  } catch {
    console.error('Error storing active event');
  }
}

export default {
  getLoginKey,
  setLoginKey,
  getEmail,
  setEmail,
  getActiveEvent,
  setActiveEvent,
};
